import {TestingPresetConfig} from '../../models/debugging/testing-preset-config';
import {isNotNullOrUndefined} from 'codelyzer/util/isNotNullOrUndefined';
import {env} from '../../../core/utils/utils';

export class TestingPresetsService {

    private static configs: TestingPresetConfig[];
    private static activePresets: string[] = [];

    static init(presetsConfig: TestingPresetConfig[], presetsUrlParamValue: string): void {
        this.configs = presetsConfig;
        this.initPresetsFromUrlParam(presetsUrlParamValue);
    }

    static isPresetActive(presetKey: string): boolean {
        return this.activePresets.includes(presetKey);
    }

    private static initPresetsFromUrlParam(presetsUrlParamValue: string): void {
        if (isNotNullOrUndefined(presetsUrlParamValue)) {
            this.activePresets = presetsUrlParamValue.split(',')
                .filter(presetKey => this.isPresetAllowed(presetKey));
        }
    }

    private static isPresetAllowed(presetKey: string): boolean {
        const config = this.getConfig(presetKey);
        return config ? config.envs.includes(env()) : false;
    }

    private static getConfig(presetKey: string): TestingPresetConfig {
        return this.configs.find(config => config.presetKey === presetKey);
    }

}
